

export const EVENT_TYPES = [
    "Application",
    "Government",
    "Gov-Internal",
]

export const REMINDER_UNITS = [
    { label: 'Hours', value: 'hours' },
    { label: 'Days', value: 'days' },
    { label: 'Weeks', value: 'weeks' },
    { label: 'Months', value: 'months' },
];

export const REPEAT_OPTIONS = [
    { label: 'Does not repeat', value: 'once' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' },
];

export const MODE_OPTIONS = [
    { label: 'Online', value: 'online' },
    { label: 'In Person', value: 'in_person' },
    { label: 'Hybrid', value: 'hybrid' },
]


export const parseDate = (isoStr: string | Date): Date => new Date(isoStr);